export enum SaleUnitCartStatusEnum {
  AVAILABLE = 1,
  OPEN = 2,
  PENDING_CHECKOUT = 3,
  CHECKOUT_COMPLETE = 4
}
